module.exports = __webpack_public_path__ + "img/ages-branco.6e0539e6.svg";